const boardDefinition = [
        {
            name: "Operations",
            id: 'operations-sfgsghsfedghsdfghsdfhsdfgh',
            layout: ["Sales", "General", "Collections", "Billing", "Faults", "Complaints", "Campaign", "Escalation"],
            widgets: [
                        {
                            "name": "Sales",
                            "arn": [
                                "Sales_queue_arn"
                            ],
                            "statistic": [
                                "CONTACTS_IN_QUEUE"
                            ],
                            "type": "current",
                            "thresholds": {}
                        },
                        {
                            "name": "General",
                            "arn": [
                                "General_queue_arn"
                            ],
                            "statistic": [
                                "CONTACTS_HANDLED"
                            ],
                            "type": "historical",
                            "thresholds": {}
                        },
                        {
                            "name": "Collections",
                            "arn": [
                                "Collections_queue_arn"
                            ],
                            "statistic": [
                                "ABANDON_TIME"
                            ],
                            "type": "historical",
                            "thresholds": {}
                        },
                        {
                            "name": "Billing",
                            "arn": [
                                "Billing_queue_arn"
                            ],
                            "statistic": [
                                "AGENTS_AVAILABLE"
                            ],
                            "type": "current",
                            "thresholds": {}
                        },
                        {
                            "name": "Faults",
                            "arn": [
                                "Faults_queue_arn"
                            ],
                            "statistic": [
                                "LONGEST_WAITING"
                            ],
                            "type": "Real-Time",
                            "thresholds": {}
                        },
                        {
                            "name": "Complaints",
                            "arn": [
                                "Complaints_queue_arn"
                            ],
                            "statistic": [
                                "HOLD_TIME"
                            ],
                            "type": "historical",
                            "thresholds": {}
                        },
                        {
                            "name": "Campaign",
                            "arn": [
                                "General_queue_arn"
                            ],
                            "statistic": [
                                "CALLBACKS_WAITING"
                            ],
                            "type": "callback",
                            "thresholds": {}
                        },
                        {
                            "name": "Escalations",
                            "arn": [
                                "Escalations_queue_arn"
                            ],
                            "statistic": [
                                "SERVICE_LEVEL"
                            ],
                            "type": "historical",
                            "thresholds": {}
                        },
                        {
                            "name": "Media",
                            "arn": "Media_queue_arn",
                            "statistic": [
                                "LONGEST_WAITING"
                            ],
                            "type": "Real-Time",
                            "thresholds": {}
                        },
                        {
                            "name": "Helpdesk",
                            "arn": "Helpdesk_queue_arn",
                            "statistic": [
                                "LONGEST_WAITING"
                            ],
                            "type": "Real-Time",
                            "thresholds": {}
                        },
                        {
                            "name": "IT Support",
                            "arn": "IT Support_queue_arn",
                            "statistic": [
                                "LONGEST_WAITING"
                            ],
                            "type": "Real-Time",
                            "thresholds": {}
                        },
                        {
                            "name": "HR",
                            "arn": "HR_queue_arn",
                            "statistic": [
                                "LONGEST_WAITING"
                            ],
                            "type": "Real-Time",
                            "thresholds": {}
                        },
                        {
                            "name": "Roster Team",
                            "arn": "Roster Team_queue_arn",
                            "statistic": [
                                "LONGEST_WAITING"
                            ],
                            "type": "Real-Time",
                            "thresholds": {}
                        }
                    ],
            theme: {
                'bgColor': '#fafafa',
                'cardColor': 'linear-gradient(145deg, #e1e1e1, #f0f0f0)',
                'fontColor': '#000000',
            }
        },
        {
            name: "Executive",
            id: 'executive-sgsdfgsdfgsdfgsdfgsdfgsdgfd',
            layout: ["Sales", "General", "Collections", "Billing", "Faults", "Complaints", "Campaign", "Escalation" ],
            widgets: [
                {
                    "name": "Sales",
                    "arn": [
                        "Sales_queue_arn"
                    ],
                    "statistic": [
                        "CONTACTS_IN_QUEUE"
                    ],
                    "type": "current",
                    "thresholds": {}
                },
                {
                    "name": "General",
                    "arn": [
                        "General_queue_arn"
                    ],
                    "statistic": [
                        "CONTACTS_HANDLED"
                    ],
                    "type": "historical",
                    "thresholds": {}
                },
                {
                    "name": "Collections",
                    "arn": [
                        "Collections_queue_arn"
                    ],
                    "statistic": [
                        "ABANDON_TIME"
                    ],
                    "type": "historical",
                    "thresholds": {}
                },
                {
                    "name": "Billing",
                    "arn": [
                        "Billing_queue_arn"
                    ],
                    "statistic": [
                        "AGENTS_AVAILABLE"
                    ],
                    "type": "current",
                    "thresholds": {}
                },
                {
                    "name": "Faults",
                    "arn": [
                        "Faults_queue_arn"
                    ],
                    "statistic": [
                        "LONGEST_WAITING"
                    ],
                    "type": "Real-Time",
                    "thresholds": {}
                },
                {
                    "name": "Complaints",
                    "arn": [
                        "Complaints_queue_arn"
                    ],
                    "statistic": [
                        "HOLD_TIME"
                    ],
                    "type": "historical",
                    "thresholds": {}
                },
                {
                    "name": "Campaign",
                    "arn": [
                        "General_queue_arn"
                    ],
                    "statistic": [
                        "CALLBACKS_WAITING"
                    ],
                    "type": "callback",
                    "thresholds": {}
                },
                {
                    "name": "Escalations",
                    "arn": [
                        "Escalations_queue_arn"
                    ],
                    "statistic": [
                        "SERVICE_LEVEL"
                    ],
                    "type": "historical",
                    "thresholds": {}
                },
            ],
            theme: {
                'bgColor': '#fafafa',
                'cardColor': 'linear-gradient(145deg, #e1e1e1, #f0f0f0)',
                'fontColor': '#000000',
            }
        },
    ];

const queueList = [
        {
            "name": "Sales",
            "arn": "Sales_queue_arn",
        },
        {
            "name": "General",
            "arn": "General_queue_arn",

        },
        {
            "name": "Collections",
            "arn": "Collections_queue_arn",
        },
        {
            "name": "Billing",
            "arn": "Billing_queue_arn",
        },
        {
            "name": "Faults",
            "arn": "Faults_queue_arn",
        },
        {
            "name": "Complaints",
            "arn": "Complaints_queue_arn",
        },
        {
            "name": "Campaign",
            "arn": "Campaign_queue_arn",
        },
        {
            "name": "Escalations",
            "arn": "Escalations_queue_arn",
        },
        {
            "name": "Media",
            "arn": "Media_queue_arn",
        },
        {
            "name": "Helpdesk",
            "arn": "Helpdesk_queue_arn",
        },
        {
            "name": "IT Support",
            "arn": "IT Support_queue_arn",
        },
        {
            "name": "HR",
            "arn": "HR_queue_arn",
        },
        {
            "name": "Roster Team",
            "arn": "Roster Team_queue_arn",
        },
    ];
    
const currentMetrics = [
    {
        Name : "AGENTS_ONLINE",
        Unit : "COUNT"
    },
    {
        Name : "AGENTS_AVAILABLE",
        Unit : "COUNT"
    },
    {
        Name : "OLDEST_CONTACT_AGE",
        Unit : "SECONDS"
    },
    {
        Name: "CONTACTS_IN_QUEUE",
        Unit: "COUNT"
    },
    {
        Name: 'AGENTS_AFTER_CONTACT_WORK',
        Unit: 'COUNT'
    },
    {
        Name: 'AGENTS_ERROR',
        Unit: 'COUNT'
    }, 
    {
        Name: 'AGENTS_NON_PRODUCTIVE',
        Unit: 'COUNT'
    }, 
    {
        Name: 'AGENTS_ON_CALL',
        Unit: 'COUNT'
    }, 
    {
        Name: 'AGENTS_ON_CONTACT',
        Unit: 'COUNT'
    }, 
    {
        Name: 'AGENTS_STAFFED',
        Unit: 'COUNT'
    }, 
    {
        Name: 'CONTACTS_SCHEDULED',
        Unit: 'COUNT'
    }, 
    {
        Name: 'SLOTS_ACTIVE',
        Unit: 'COUNT'
    }, 
    {
        Name: 'SLOTS_AVAILABLE',
        Unit: 'COUNT'
    }, 
    
];

const ccxCurrentMetrics = [
    {
        Name: "agentsAvailable",
        Unit : "COUNT"
    },
    {
        Name: "agentsInError",
        Unit : "COUNT"
    },
    {
        Name: "agentsInWrap",
        Unit : "COUNT"
    },
    {
        Name: "agentsStaffed",
        Unit : "COUNT"
    },
    {
        Name: "agentsUnavailable",
        Unit : "COUNT"
    },
    {
        Name: "agentsWorking",
        Unit : "COUNT"
    },
    {
        Name: "itemsBeingDelivered",
        Unit : "COUNT"
    },
    {
        Name: "itemsInQueue",
        Unit : "COUNT"
    },
    {
        Name: "oldestItem",
        Unit : "SECONDS"
    },
];

const ccxHistoricalMetrics = [
    {
        Name: "AvgActiveDuration",
        Unit : "SECONDS"
    },
    {
        Name: "AvgQueuedDuration",
        Unit : "SECONDS"
    },
    {
        Name: "Forward",
        Unit : "COUNT"
    },
    {
        Name: "Inbound",
        Unit : "COUNT"
    },
    {
        Name: "InboundReply",
        Unit : "COUNT"
    },
    {
        Name: "Outbound",
        Unit : "COUNT"
    },
];

const historicalMetrics = [
    {
        Name : "ABANDON_TIME",
        Unit : "SECONDS",
        Statistic: "AVG"
    },
    {
        Name : "AFTER_CONTACT_WORK_TIME",
        Unit : "SECONDS",
        Statistic: "AVG"
    },
    {
        Name : "API_CONTACTS_HANDLED",
        Unit : "COUNT",
        Statistic: "SUM"
    },
    {
        Name : "CONTACTS_QUEUED",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_HANDLED",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CALLBACK_CONTACTS_HANDLED",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "HANDLE_TIME",
        Unit : "SECONDS",
        Statistic : "AVG"
     },
     {
        Name : "HOLD_TIME",
        Unit : "SECONDS",
        Statistic : "AVG"
     },
     {
        Name : "CONTACTS_TRANSFERRED_OUT",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_TRANSFERRED_OUT_FROM_QUEUE",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_TRANSFERRED_IN",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_TRANSFERRED_IN_FROM_QUEUE",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_CONSULTED",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_MISSED",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "CONTACTS_ABANDONED",
        Unit : "COUNT",
        Statistic : "SUM"
     },
     {
        Name : "OCCUPANCY",
        Unit : "PERCENT",
        Statistic : "AVG"
     },
     {
        Name : "QUEUED_TIME",
        Unit : "SECONDS",
        Statistic : "MAX"
     },
     {
        Name : "QUEUE_ANSWER_TIME",
        Unit : "SECONDS",
        Statistic : "AVG"
     },
     {
        Name : "SERVICE_LEVEL_60",
        "Threshold" : {
           "Comparison" : "LT",
           "ThresholdValue" : 60.0
        },
        Unit : "PERCENT",
        Statistic : "AVG"
     },
     {
        Name : "SERVICE_LEVEL_120",
        "Threshold" : {
           "Comparison" : "LT",
           "ThresholdValue" : 120.0
        },
        Unit : "PERCENT",
        Statistic : "AVG"
     },
     {
        Name : "SERVICE_LEVEL_30",
        "Threshold" : {
           "Comparison" : "LT",
           "ThresholdValue" : 30.0
        },
        Unit : "PERCENT",
        Statistic : "AVG"
     },
     { 
         Name: "CONTACTS_AGENT_HUNG_UP_FIRST",
         Unit: "COUNT",
         Statistic: "SUM"
     },
     { 
         Name: "CONTACTS_HANDLED_INCOMING",
         Unit: "COUNT",
         Statistic: "SUM"
     }, 
     { 
      Name: "CONTACTS_HANDLED_OUTBOUND",
      Unit: "COUNT",
      Statistic: "SUM"
   },
   { 
      Name: "CONTACTS_HOLD_ABANDONS",
      Unit: "COUNT",
      Statistic: "SUM"
   },
   { 
      Name: "INTERACTION_AND_HOLD_TIME",
      Unit: "SECONDS",
      Statistic: "AVG"
   },
   { 
      Name: "INTERACTION_TIME",
      Unit: "SECONDS",
      Statistic: "AVG"
   },
];

const historicalMetricsV2 = [
    
    {
        Name: "ABANDONMENT_RATE",
        Unit: "PERCENT",
        Statistic: "AVG"
    },
    {
        Name: "AGENT_NON_RESPONSE",
        Unit: "PERCENT",
        Statistic: "AVG"
    },
    {
        Name: "AVG_ABANDON_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_AFTER_CONTACT_WORK_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_CONTACT_DURATION",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_CONVERSATION_DURATION",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_GREETING_TIME_AGENT",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_HANDLE_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_HOLDS",
        Unit: "COUNT",
        Statistic: "AVG"
    },
    {
        Name: "AVG_HOLD_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_INTERACTION_AND_HOLD_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_INTERACTION_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_INTERRUPTIONS_AGENT",
        Unit: "COUNT",
        Statistic: "AVG"
    },
    {
        Name: "AVG_INTERRUPTION_TIME_AGENT",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_NON_TALK_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_QUEUE_ANSWER_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_RESOLUTION_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_TALK_TIME",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_TALK_TIME_AGENT",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "AVG_TALK_TIME_CUSTOMER",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "CONTACTS_ABANDONED",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_CREATED_QUEUE_TRANSFER",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HANDLED",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HANDLED_AGENT_DISCONNECT",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HANDLED_API",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HANDLED_CALLBACK",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HANDLED_INCOMING",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HANDLED_OUTBOUND",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_HOLD_ABANDONS",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_QUEUED",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_TRANSFERRED_IN",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_TRANSFERRED_OUT",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "CONTACTS_TRANSFERRED_OUT_FROM_QUEUE",
        Unit: "COUNT",
        Statistic: "SUM"
    },
    {
        Name: "MAX_QUEUED_TIME",
        Unit: "SECONDS",
        Statistic: "SUM"
    },
    {
        Name: "SERVICE_LEVEL_120",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "SERVICE_LEVEL_30",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "SERVICE_LEVEL_60",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
    {
        Name: "SERVICE_LEVEL_20",
        Unit: "SECONDS",
        Statistic: "AVG"
    },
];
   

export {boardDefinition, queueList, currentMetrics, historicalMetrics, historicalMetricsV2, ccxCurrentMetrics, ccxHistoricalMetrics};